var render = function render(){var _vm=this,_c=_vm._self._c;return _c('defNavBar',{attrs:{"title":"Ares - Update multiple night prices","info":[
      {label: 'Accommodation:', value: _vm.hspt.accommodation}, 
      {label: 'Contract: ', value: _vm.hspt.cttptaal_oms},
      {label: 'Arrivals: ', value: `${this.hspt.start_date} - ${this.hspt.end_date}`}],"home":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }